import {selectDrillInCard} from 'hsi/selectors';
import {CardType} from 'hsi/types/cards';
import {useAppSelector} from './useRedux';

const useIsCardSelected = (type: CardType) => useAppSelector(selectDrillInCard) === type;

export default useIsCardSelected;
